import React from 'react';
import { Tooltip } from 'primereact/tooltip';

interface EditIntegrationButtonProps {
  onClick?: (_event: React.MouseEvent<HTMLDivElement>) => void;
  onDelete?: (_event: React.MouseEvent<HTMLElement>) => void;
  integrationName?: string;
  vendorName?: string;
  userName?: string;
  password?: string;
  url?: string;
}

export const EditIntegrationButton: React.FC<EditIntegrationButtonProps> = ({
  onClick,
  onDelete,
  integrationName,
  vendorName,
}) => {
  return (
    <div
      className="edit-integration-button flex flex-column align-items-center justify-content-center p-4 cursor-pointer relative"
      onClick={onClick}
      style={{
        border: '1px solid #ccc',
        borderRadius: '12px',
        width: '100%',
        height: '150px',
        transition: 'all 0.3s',
        position: 'relative',
      }}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
    >
      {/* Vendor name in top left corner */}
      {vendorName && (
        <div
          className="vendor-name absolute"
          style={{
            position: 'absolute',
            top: '8px',
            left: '8px',
            fontWeight: 'bold',
            maxWidth: '60%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          {vendorName}
        </div>
      )}

      {/* Trash can icon in top right corner */}
      <div
        className="delete-icon absolute"
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          cursor: 'pointer',
          color: '#ff5757',
          zIndex: 2,
          padding: '4px',
          borderRadius: '4px',
          transition: 'all 0.2s',
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 87, 87, 0.1)')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
        onClick={(e) => {
          e.stopPropagation(); // Prevent triggering the parent onClick
          if (onDelete) onDelete(e);
        }}
      >
        <i
          className="pi pi-trash trash-icon"
          data-pr-tooltip="Delete Integration"
          data-pr-position="left"
          data-pr-at="left-5 top"
        ></i>
        <Tooltip target=".trash-icon" />
      </div>

      <div
        className="edit-circle flex align-items-center justify-content-center mb-2"
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          border: '1px solid #4F46E5',
          color: '#4F46E5',
        }}
      >
        <i className="pi pi-pencil"></i>
      </div>
      <div
        className="button-text text-color-secondary"
        style={{
          maxWidth: '90%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'center',
        }}
      >
        {integrationName || 'Integration'}
      </div>
    </div>
  );
};
